import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const GetPostprocessingDataEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.fetchPostprocessingData.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return OrderRepository.getPostprocessingData(action.payload.orderId).pipe(
        mergeMap((response) => of(order.fetchPostprocessingDataResult({ result: response }))),
        catchError((error: Error) => {
          console.warn('error fetching postprocessing data, this may just indicate its not there yet', error)
          return of(order.fetchPostprocessingDataResult({ result: null }))
        })
      )
    })
  )
